export interface Routes {
  [key: string]: string;
}

type Params = Record<string, string | number>;

export const buildRoute = (baseRoute: string, params: Params) => {
  return baseRoute
    .replace(/\{(\w+)\}/g, (_, key) => {
      if (params[key] !== undefined && params[key] !== null) {
        return encodeURIComponent(params[key]);
      }
      return "";
    })
    .replace(/\/+/g, "/");
};

export const noEnvRoutes: Routes = {
  createInspection: "inspections",
  getAnswers: "answers/inspections/{inspectionId}/phases/{phaseId}",
  getQuestions: "questions?inspection_type={id}",
  getInspectionBySnStand: "inspections/carro?snStand=",
  getInspections: "inspections",
  getInspectionById: "inspections/{id}",
  updateInpectionId: "inspections/{id}",
  deleteInspectionId: "inspections/{id}",
  postImage: "s3/presigned-url",
  getImage: "s3/presigned-url",
  postAnswer: "answers/inspections/{inspectionId}/phases/{phaseId}",
  updateAnswer: "answers/inspections/{inspectionId}/phases/{phaseId}/{id}",
  deletedAnswer: "answers/inspections/{inspectionId}/phases/{phaseId}/{id}",
  getQuestionsByInspection: "inspections-type/{inspection_type}",
  updatePhase: "inspections/{inspectionId}/phases/{phaseId}",
  inspectionsType: "inspections-type",
  inspectionsTypeId: "inspections-type/{id}",
  getInspectionPDF: "inspections/{id}/document",
  postImportCsvInspections: "inspections/import",
  importSharePointInspections: "inspections/manual-import",
  completePhaseWhitNa:
    "/answers/inspections/{inspectionId}/phases/{phaseId}/complete",
};

export const promiseAllRoutes: Routes = {};

const routes: Routes = Object.fromEntries(
  Object.entries(noEnvRoutes).map(([routeKey, route]) => [
    routeKey,
    `/v1/${route}`,
  ]),
);

export default routes;
